import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a436aca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-member-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Investigation team", -1))
const _hoisted_5 = {
  key: 0,
  class: "body-main has-indicator"
}
const _hoisted_6 = {
  key: 1,
  class: "body-main has-indicator"
}
const _hoisted_7 = {
  key: 2,
  class: "body-main"
}
const _hoisted_8 = { class: "user-form" }
const _hoisted_9 = { class: "ls-form" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Search user *", -1))
const _hoisted_11 = { class: "autocomplete search-user-input" }
const _hoisted_12 = { class: "icon-hm" }
const _hoisted_13 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_14 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_15 = {
  id: "autocomplete-results",
  class: "autocomplete-results"
}
const _hoisted_16 = ["innerHTML", "onClick"]
const _hoisted_17 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_19 = { class: "aad-user-info mt-4 mb-4" }
const _hoisted_20 = { class: "form-col" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name", -1))
const _hoisted_22 = { class: "form-col" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_24 = { class: "form-col" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Security group/s", -1))
const _hoisted_26 = { class: "onerow-twocol-wrapper" }
const _hoisted_27 = { class: "colone" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Role *", -1))
const _hoisted_29 = { class: "select-wrapper" }
const _hoisted_30 = { class: "select" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: "",
  selected: ""
}, "-- Select role --", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Charge amount *", -1))
const _hoisted_36 = { class: "input-box" }
const _hoisted_37 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_39 = { class: "coltwo" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Supervisor", -1))
const _hoisted_41 = { class: "select-wrapper" }
const _hoisted_42 = { class: "select" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: undefined,
  disabled: "",
  selected: ""
}, "-- Select supervisor --", -1))
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 0,
  class: "onerow-twocol-wrapper"
}
const _hoisted_46 = { class: "colone" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start date (for timesheets) *", -1))
const _hoisted_48 = { class: "date-picker" }
const _hoisted_49 = {
  key: 0,
  class: "fal fa-calendar-check"
}
const _hoisted_50 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_52 = { class: "coltwo" }
const _hoisted_53 = { class: "date-picker" }
const _hoisted_54 = {
  key: 0,
  class: "custom-icon fal fa-calendar-check"
}
const _hoisted_55 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_57 = { class: "controls mt-4" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_v3_date_picker = _resolveComponent("v3-date-picker")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[14] || (_cache[14] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.editMode ? 'Edit ' + _ctx.teamMember.displayName : 'Add new user'), 1),
          _hoisted_4
        ])
      ]),
      body: _withCtx(() => [
        (_ctx.loadingContent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_LoadingIndicator)
            ]))
          : (_ctx.errorLoadingContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_ErrorIndicator)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("form", _hoisted_9, [
                    _createElementVNode("fieldset", null, [
                      (!_ctx.editMode)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_10,
                            _createElementVNode("div", _hoisted_11, [
                              _withDirectives(_createElementVNode("input", {
                                onKeydown: [
                                  _cache[0] || (_cache[0] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                                  _cache[1] || (_cache[1] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                                  _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
                                ],
                                class: "searchField",
                                type: "text",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.search) = $event)),
                                placeholder: "Search by Name or Email"
                              }, null, 544), [
                                [_vModelText, _ctx.search]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "hidden",
                                id: "member",
                                name: "member",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.formData.externalId) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.formData.externalId]
                              ]),
                              _createElementVNode("span", _hoisted_12, [
                                (_ctx.isSearching)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_14))
                              ]),
                              _withDirectives(_createElementVNode("ul", _hoisted_15, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.memberList, (member, i) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: i,
                                    class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]),
                                    innerHTML: _ctx.highlightWord(member.displayName + ' | ' + member.email),
                                    onClick: _withModifiers($event => (_ctx.selectMember(member)), ["prevent"])
                                  }, null, 10, _hoisted_16))
                                }), 128))
                              ], 512), [
                                [_vShow, _ctx.isOpen]
                              ]),
                              (!_ctx.formData.externalId)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _hoisted_18,
                                    _createTextVNode(" Mandatory field ")
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      (!!_ctx.formData.externalId)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("div", null, _toDisplayString(_ctx.formData.displayName), 1)
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("div", null, _toDisplayString(_ctx.formData.email), 1)
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("div", null, _toDisplayString(_ctx.formData.securityGroups), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.formData.userGroup.id) = $event))
                                    }, [
                                      _hoisted_31,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userGroups, (ug) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          value: ug.id
                                        }, _toDisplayString(ug.name), 9, _hoisted_32))
                                      }), 256))
                                    ], 512), [
                                      [_vModelSelect, _ctx.formData.userGroup.id]
                                    ])
                                  ])
                                ]),
                                (!_ctx.formData.userGroup.id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                      _hoisted_34,
                                      _createTextVNode(" Mandatory field ")
                                    ]))
                                  : _createCommentVNode("", true),
                                (!!_ctx.formData.userGroup?.id && _ctx.formData.userGroup?.id !== 1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _hoisted_35,
                                      _createElementVNode("div", _hoisted_36, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "number",
                                          placeholder: "0.00",
                                          min: "0",
                                          step: ".01",
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.formData.chargeAmount) = $event))
                                        }, null, 512), [
                                          [_vModelText, _ctx.formData.chargeAmount]
                                        ]),
                                        (_ctx.formData.chargeAmount === null || isNaN(_ctx.formData.chargeAmount))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                              _hoisted_38,
                                              _createTextVNode(" Mandatory field ")
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                (!!_ctx.formData.userGroup?.id && _ctx.formData.userGroup?.id !== 1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _hoisted_40,
                                      _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                          _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.formData.supervisor.id) = $event))
                                          }, [
                                            _hoisted_43,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supervisorList, (s) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                value: s.id
                                              }, _toDisplayString(s.displayName), 9, _hoisted_44))
                                            }), 256))
                                          ], 512), [
                                            [_vModelSelect, _ctx.formData.supervisor.id]
                                          ])
                                        ])
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            ((!!_ctx.formData.userGroup?.id && _ctx.formData.userGroup?.id !== 1) || (_ctx.teamMember.userGroup?.id > 1 && _ctx.formData.userGroup?.id == 1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _hoisted_47,
                                    _createElementVNode("div", _hoisted_48, [
                                      _createVNode(_component_v3_date_picker, {
                                        class: "v3-date-picker",
                                        modelValue: _ctx.startDateForTimesheet,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.startDateForTimesheet) = $event)),
                                        style: {"padding":"1em"},
                                        inputFormat: "dd-MM-yyyy",
                                        upperLimit: _ctx.endDateForTimesheet
                                      }, null, 8, ["modelValue", "upperLimit"]),
                                      (!_ctx.startDateForTimesheet)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_49))
                                        : (_openBlock(), _createElementBlock("i", {
                                            key: 1,
                                            class: "fal fa-times clearBtn",
                                            onClick: _cache[9] || (_cache[9] = $event => (_ctx.startDateForTimesheet = null))
                                          }))
                                    ]),
                                    (!_ctx.startDateForTimesheet)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                          _hoisted_51,
                                          _createTextVNode(" Mandatory field ")
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    (_ctx.editMode)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("label", null, "End date (for timesheets) " + _toDisplayString((_ctx.teamMember.userGroup?.id > 1 && _ctx.formData.userGroup?.id == 1) ? '*' : ''), 1),
                                          _createElementVNode("div", _hoisted_53, [
                                            _createVNode(_component_v3_date_picker, {
                                              class: "v3-date-picker",
                                              modelValue: _ctx.endDateForTimesheet,
                                              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.endDateForTimesheet) = $event)),
                                              style: {"padding":"1em"},
                                              inputFormat: "dd-MM-yyyy",
                                              lowerLimit: _ctx.startDateForTimesheet
                                            }, null, 8, ["modelValue", "lowerLimit"]),
                                            (!_ctx.endDateForTimesheet)
                                              ? (_openBlock(), _createElementBlock("i", _hoisted_54))
                                              : (_openBlock(), _createElementBlock("i", {
                                                  key: 1,
                                                  class: "fal fa-times clearBtn",
                                                  onClick: _cache[11] || (_cache[11] = $event => (_ctx.endDateForTimesheet = null))
                                                }))
                                          ]),
                                          (_ctx.teamMember.userGroup?.id > 1 && _ctx.formData.userGroup?.id == 1 && !_ctx.endDateForTimesheet)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                _hoisted_56,
                                                _createTextVNode(" Mandatory field ")
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("button", {
                      class: "btn btn-default ml-1",
                      disabled: _ctx.submitting,
                      onClick: _cache[12] || (_cache[12] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
                    }, "Back", 8, _hoisted_58),
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      disabled: _ctx.submitting || !(_ctx.isFormDirty && _ctx.validForm),
                      onClick: _cache[13] || (_cache[13] = _withModifiers($event => (_ctx.saveTrustTeamMember()), ["prevent","stop"]))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.editMode ? 'Save changes' : 'Add user'), 1),
                      _hoisted_60
                    ], 8, _hoisted_59),
                    (_ctx.submitting)
                      ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                          key: 0,
                          class: "loading-indicator",
                          showLoadingText: false
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
      ]),
      _: 1
    })
  ]))
}